import yup from './yup'

export const sponsorshipLevelFormSchema = yup.object().shape({
  category: yup.string().label('Category').trimmedRequired('Category is a required field'),
  categoryLevel: yup
    .number()
    .integer()
    .positive()
    .label('Category Level')
    .typeError('Category Level should be a positive number')
    .required()
})
